import {Button, Divider} from '@flixbus/honeycomb-react';
import {Icon, IconCalculator} from '@flixbus/honeycomb-icons-react';
import {NavLink} from 'react-router';
import {ProductionCostCalculationPath} from '@/Pages/ProductionCost/constants/routePaths';
import HomeFilters from './FiltersContainer';
import Calculations from './Calculations';
import Footer from './Footer';

const Home = () => {
  return (
    <div>
      <NavLink
        to={ProductionCostCalculationPath.create.selectSchedules}
        style={{textDecoration: 'none'}}
      >
        <Button extraClasses="home-button" appearance="primary">
          <Icon InlineIcon={IconCalculator} aria-hidden="true" />
          New calculation
        </Button>
      </NavLink>

      <Divider />
      <HomeFilters />
      <Divider />

      <Calculations />
      <Footer />
    </div>
  );
};

export default Home;
